import { useTranslation, Trans } from 'react-i18next';
import React from 'react';
import { MobileModal } from '@/components/shared';
import { IconClose, IconGooglePlay } from '@/assets/download';

import { useSwitch } from '@/hooks';

import styles from './index.module.scss';

const downloadList = [
  {
    downloadText: (
      <Trans i18nKey="AndroidDownloadModal.l2g5a3">
        Download on <b>Google Play</b>
      </Trans>
    ),
    Icon: IconGooglePlay,
    downloadUrl: 'https://play.google.com/store/apps/details?id=com.debank.meme',
  },
];

export const AndroidDownloadModal = () => {
  const { t } = useTranslation();

  const { on, turn } = useSwitch(true);

  return (
    <MobileModal
      diyStyle={{
        padding: 17,
      }}
      width={316}
      modalIsOpen={on}
      setIsShow={turn}>
      <div className={styles.closeBtn} onClick={() => turn(false)}>
        <IconClose />
      </div>
      <div className={styles.modalHeader}>{t('AndroidDownloadModal.5tny8p')}</div>
      <div className={styles.modalBody}>
        {downloadList.map(({ downloadText, Icon, downloadUrl }) => (
          <a href={downloadUrl} rel="noreferrer">
            <div className={styles.download}>
              <span className={styles.icon}>
                <Icon />
              </span>
              <span>{downloadText}</span>
            </div>
          </a>
        ))}
      </div>
    </MobileModal>
  );
};
